!function () {

    var _this = window;

    window.Api = function(type,url,pram){
       
        return new Promise(function(resolve, reject) {
			var key  = CryptoJS.enc.Latin1.parse('1234567890123456');
			var iv   = CryptoJS.enc.Latin1.parse('1201230125462244');
			var params={}, publickey = "";
			if(!!sessionStorage.safeInfo){
				var decrypted = CryptoJS.AES.decrypt(sessionStorage.safeInfo,key,{iv:iv,padding:CryptoJS.pad.Pkcs7}).toString(CryptoJS.enc.Utf8);
				var encrypt = new JSEncrypt();
				params.appKey = JSON.parse(decrypted).appKey;
				params.secret = JSON.parse(decrypted).secret;
				params.nowDate = window.NewLog._Format("yyyy-MM-dd hh:mm:ss");
				encrypt.setPublicKey(JSON.parse(decrypted).publicKey);
				publickey = encrypt.encrypt(JSON.stringify(params));
			}
            $.ajax({
                url: url,
                type: type,
                dataType : 'json',
                contentType: 'application/json',
                data: null || pram,
                headers:{'Content-Type':'application/json;charset=utf8','code': params.appKey,'key': publickey},
                success: function(response){
                    resolve(response);
                },
                error: function(err) {
                    reject(err);
                }
            });
        })
    };

    window.Tool = {
        instance:null,
        _scroll:function(dom,top)
        {
            if(_this.Tool.instance){
                clearInterval(_this.Tool.instance);
            }
            var oraTop = dom.scrollTop;
            var time = 10; // 每次动画的间隔
            var dur = 500; // 整个滑动动画的时长
            var totalPx = top - oraTop;
            var tmpDur = time;

            _this.Tool.instance = setInterval(function(){
                var step = totalPx * Math.sin(Math.PI*tmpDur/(2*dur));
                step = Math.round(step);

                var target = oraTop + step;
                if((target - top)*(target - top) < 4){ // 最后2px一次到位
                    _this.Tool._fallbackSc(dom,top);
                    clearInterval(_this.Tool.instance);
                    return;
                }
                _this.Tool._fallbackSc(dom,target);
                tmpDur+=time;
                if(dom.scrollTop !== target)
                {
                    clearInterval(_this.Tool.instance);
                }
            },time);
        },
        _fallbackSc:function(dom,y){
            if(dom.scrollTo){
                dom.scrollTo(0,y);
            }else{
                dom.scrollTop = y;
            }
        }
    };

    window.ToScroll={
        _scroll:function(dom,top){
            var oraTop = top;
            var time = 10; // 每次动画的间隔时长
            var dur = 500; // 整个滑动动画的时长
            var scroll= parseInt(oraTop/dur*time); // 每次动画的间隔距离
            var t=setInterval(function(){
                dom.scrollTop = dom.scrollTop + scroll;
                if(dom.scrollTop >= (oraTop)){
                    clearInterval(t);
                }
            },time)
        }
    };

    window.changeNum={
        _formatNum:function(str){
            var newStr = "";
            var count = 0;

            if(str.indexOf(".")==-1){
                for(var i=str.length-1;i>=0;i--){
                    if(count % 3 == 0 && count != 0){
                        newStr = str.charAt(i) + "," + newStr;
                    }else{
                        newStr = str.charAt(i) + newStr;
                    }
                    count++;
                }
                str = newStr;
            }
            else
            {
                for(var i = str.indexOf(".")-1;i>=0;i--){
                    if(count % 3 == 0 && count != 0){
                        newStr = str.charAt(i) + "," + newStr;
                    }else{
                        newStr = str.charAt(i) + newStr; //逐个字符相接起来
                    }
                    count++;
                }
                str = newStr + str.substr(str.indexOf("."),3);
            }
            return str;
        }
    }
    window.NewLog={
        _data: null,
        _saveLog: function(visitModel,visitModelName,visitModelDetailId,visitModelDetailName,visitAction,description){
            var params={
                srcProvince:"浙江省",
                srcClientType:"WEB_12348",
                srcClientTypeName:"Web12348法网",
                visitModel:visitModel,
                // visitModelName:visitModelName,
                visitModelDetailId:visitModelDetailId,
                visitModelDetailName:visitModelDetailName,
                visitAction:visitAction,
                userId:localStorage.sysUserId,
                visitTime:this._Format("yyyy-MM-dd hh:mm:ss"),
                description:description||null
            },me=this;
            $.ajax({
                url:"/api/visitlog/newLog",
                type:"post",
                dataType : 'json',
                contentType: 'application/json',
                data: JSON.stringify(params),
                success: function(response){
                    me._data = response;
                },
                error: function(err) {

                }
            });
        },
         _Format: function (fmt) {
          var date=new Date();
          var o = {
            "M+": date.getMonth() + 1,            //月份
            "d+": date.getDate(),               //日
            "h+": date.getHours(),               //小时
            "m+": date.getMinutes(),             //分
            "s+": date.getSeconds(),             //秒
            "q+": Math.floor((date.getMonth() + 3) / 3),   //季度
            "S": date.getMilliseconds()            //毫秒
          };
          if (/(y+)/.test(fmt))
            fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
          for (var k in o)
            if (new RegExp("(" + k + ")").test(fmt))
              fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
          return fmt;
        }
    }
}();



//////////////////
// WEBPACK FOOTER
// ./src/service/public.js
// module id = 353
// module chunks = 1